import React, { Fragment, useState, useEffect, useRef, useContext } from "react";
import { Col, Row, Form, Button } from "reactstrap";
import SikkaInput from "../common/SikkaInput";
import { useForm } from "react-hook-form";
import SikkaDropzone from "../common/SikkaDropzone";
import { toast } from "react-toastify";
import { isIterableArray } from "../../helpers/utils";
import AppContext from "../../context/Context";
import defaultAppLogo from "../../assets/img/icons/DefaultAppLogo.png";
import imageToBase64 from "image-to-base64";
import Loader from "../common/Loader";

const AddEditApplicationForm = (props) => {
  const {
    isAddMode,
    recordForEdit,
    setOpenPopupForAddEditApplication,
    addEditApplicationDetails,
    applicationData,
    avatarChanged,
    setAvatarChanged,
    setFetchAfterUpdate,
    applicationListData,
    partnerDetails,
  } = props;
  const [devMobile, setDevMobile] = useState("");
  const [devPhone, setDevPhone] = useState("");
  const [avatar, setAvatar] = useState([{ src: "" }]); //[{ src: "https://ui-avatars.com/api/?name=renish&background=random" }]
  const [redirectUrlIsHide, setRedirectUrlIsHide] = useState(false);
  const [files, setFiles] = React.useState([]);

  const [newAppName, setNewAppName] = useState(applicationData.app_name);
  const [newAppDesc, setNewAppDesc] = useState(applicationData.app_desc);
  const [newAppWebsiteURL, setNewAppWebisteURL] = useState(applicationData.app_site_url);
  const [newAppRedirectURL, setNewAppRedirectURL] = useState(applicationData.redirect_uri);
  const [clearbitImg, setClearBitImg] = useState("");
  const [defaultLogoBoolean, setDefaultLogoBoolean] = useState(false);
  const [loading, setLoading] = useState(false);

  const { loginUserDetails } = useContext(AppContext);

  useEffect(() => {
    if (partnerDetails?.username) {
      let idx = partnerDetails.username.indexOf("@");
      setClearBitImg(partnerDetails.username.slice(idx + 1));
    }
  }, [partnerDetails?.username]);

  const { register, handleSubmit, setValue, errors } = useForm();

  const appNameRef = useRef();

  // var blob = new Blob([buffer], { type: "text/html" });

  function getBase64Image(image) {
    const canvas = document.createElement("canvas");

    // We use naturalWidth and naturalHeight to get the real image size vs the size at which the image is shown on the page
    canvas.width = image.naturalWidth;
    canvas.height = image.naturalHeight;

    // We get the 2d drawing context and draw the image in the top left
    canvas.getContext("2d").drawImage(image, 0, 0);

    // Convert canvas to DataURL and log to console
    const dataURL = canvas.toDataURL();
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  const onSubmit = (values) => {
    setFetchAfterUpdate(true);
    if (isAddMode) {
      if (applicationListData.length < 5) {
        if (avatar[0].base64) {
          values.base64 = avatar[0]?.base64?.split(",")[1];
          values.image_name = avatar[0].path;
        } else {
          values.base64 = getBase64Image(document.getElementById("app_logo"));
          values.image_name = "defaultSikkaAppLogo.png";
        }
        setAvatarChanged(false);
        addEditApplicationDetails(values);
        setLoading(true);
      } else {
        toast.warning(
          "Not allowed to create more than 5 application. If you want to create application please contact sikka API team."
        );
        setOpenPopupForAddEditApplication(false);
      }
    } else {
      if (avatar[0].base64) {
        values.base64 = avatar[0]?.base64?.split(",")[1];
        values.image_name = avatar[0].path;
      } else if (defaultLogoBoolean) {
        values.base64 = getBase64Image(document.getElementById("app_logo"));
        values.image_name = "defaultSikkaAppLogo.png";
      }

      if (
        recordForEdit.app_name !== values.app_name ||
        recordForEdit.app_site_url !== values.app_site_url ||
        recordForEdit.app_desc !== values.app_desc ||
        recordForEdit.redirect_uri !== values.redirect_uri ||
        avatarChanged
      ) {
        setAvatarChanged(false);
        addEditApplicationDetails(values, recordForEdit.app_id);
        setLoading(true);
      } else {
        setOpenPopupForAddEditApplication(false);
        toast.success("Application Details saved successfully");
      }
    }
  };

  useEffect(() => {
    if (!isAddMode) {
      // get user and set form fields
      const fields = [
        "dev_name",
        "partner_name",
        "username",
        "dev_address",
        "dev_mobile",
        "dev_phone",
        "dev_country",
        "dev_state",
        "dev_city",
        "dev_zip",
        "dev_site_url",
        "referred_by",
        "dev_purpose",
        "dev_status",
        "is_verified",
      ];
      fields.forEach((field) => setValue(field, recordForEdit[field]));
      setDevMobile(recordForEdit.dev_mobile); //not set using setValue()
      setDevPhone(recordForEdit.dev_phone);
    }
  }, []);

  return (
    <Fragment ref={appNameRef}>
      {!loading ? (
        isAddMode ? (
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                <SikkaInput
                  label="Application Name*"
                  name="app_name"
                  id="appName"
                  placeholder="Application Name"
                  innerRef={register({
                    required: "Application Name is required",
                    pattern: {
                      value: /^[^\s]+(\s+[^\s]+)*$/,
                      message: "Invalid Application Name",
                    },
                  })}
                  errors={errors}
                />
              </Col>
              <Col>
                <SikkaInput
                  label="WebSite URL*"
                  placeholder="WebSite URL"
                  name="app_site_url"
                  id="webSite"
                  innerRef={register({
                    required: "WebSite URL is required",
                    pattern: {
                      value: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
                      message: "Invalid WebSite URL",
                    },
                  })}
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <SikkaInput
                  label="Description (Max 200 characters are allowed)*"
                  placeholder="Description"
                  id="description"
                  maxLength={200}
                  name="app_desc"
                  innerRef={register({
                    required: "Description is required",
                    pattern: {
                      value: /^[^\s]+(\s+[^\s]+)*$/,
                      message: "Invalid Description",
                    },
                  })}
                  errors={errors}
                />
              </Col>
            </Row>

            <Row>
              <div className="col-12 col-sm-5 pl-6 mt-2 mt-sm-3 mt-lg-2 pr-sm-0 pr-6" style={{ width: "320px" }}>
                <SikkaDropzone
                  files={avatar}
                  onChange={(files) => {
                    setAvatar(files);
                    setDefaultLogoBoolean(false);
                    setAvatarChanged(true);
                  }}
                  multiple={false}
                  className="p-1"
                  accept="image/gif, image/jpeg, image/png"
                  preview={false}
                  placeholder="Select Application Logo"
                  maxSize={2097152}
                  minSize={0}
                  note="File size should not exceed 2 MB"
                />
              </div>
              <Col className="d-flex align-items-center justify-content-center">
                {avatar[0].base64 ? (
                  <img
                    id="app_logo"
                    className="img-thumbnail img-fluid mb-3 mt-2 ml-3"
                    style={{ border: "1px solid #ddd" }}
                    src={avatar[0].base64}
                    crossOrigin="anonymous"
                    width="150"
                    alt=""
                  />
                ) : (
                  <img
                    id="app_logo"
                    className="img-thumbnail img-fluid mb-3 mt-2 ml-3"
                    style={{ border: "1px solid #ddd" }}
                    src={defaultLogoBoolean ? defaultAppLogo : `https://logo.clearbit.com/${clearbitImg}`}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = defaultAppLogo;
                    }}
                    crossOrigin="anonymous"
                    width="150" 
                    alt=""
                  />
                )}
                {!defaultLogoBoolean && (
                  <Button
                    size="sm"
                    color="primary"
                    className="ml-4 mb-1"
                    onClick={() => {
                      let idx = partnerDetails.username.indexOf("@");
                      setClearBitImg(partnerDetails.username.slice(idx + 1));
                      setAvatar([{ src: "" }]);
                      setDefaultLogoBoolean(true);
                    }}
                  >
                    Reset Logo
                  </Button>
                )}
              </Col>
            </Row>

            <Row className="modal-footer px-md-4 bg-light" style={{ marginBottom: "-16px" }}>
              <Button color="outline-primary" size="sm" className="ml-auto" type="submit">
                Save
              </Button>
              <Button
                size="sm"
                color="outline-secondary"
                onClick={() => {
                  setOpenPopupForAddEditApplication(false);
                }}
              >
                Cancel
              </Button>
            </Row>
          </Form>
        ) : (
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row form>
              <Col style={{ marginRight: "15px" }}>
                <SikkaInput
                  label="Application Name*"
                  name="app_name"
                  defaultValue={applicationData.app_name}
                  id="appName"
                  disabled={loginUserDetails.is_partner === "1"}
                  placeholder="Application Name"
                  innerRef={register({
                    required: "Application Name is required",
                    pattern: {
                      value: /^[^\s]+(\s+[^\s]+)*$/,
                      message: "Invalid Application Name",
                    },
                  })}
                  errors={errors}
                />
              </Col>
              <Col style={{ marginLeft: "5px" }}>
                <SikkaInput
                  label="WebSite URL*"
                  placeholder="WebSite URL"
                  name="app_site_url"
                  defaultValue={applicationData.app_site_url}
                  id="webSite"
                  innerRef={register({
                    required: "WebSite URL is required",
                    pattern: {
                      value: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
                      message: "Invalid WebSite URL",
                    },
                  })}
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <SikkaInput
                  label="Description (Max 200 characters are allowed)*"
                  placeholder="Description"
                  defaultValue={applicationData.app_desc}
                  id="description"
                  maxLength={200}
                  name="app_desc"
                  innerRef={register({
                    required: "Description is required",
                    pattern: {
                      value: /^[^\s]+(\s+[^\s]+)*$/,
                      message: "Invalid Description",
                    },
                  })}
                  errors={errors}
                />
              </Col>
              <Col className={redirectUrlIsHide ? "hidden-sikka" : ""}>
                <SikkaInput
                  label="Redirect URI*"
                  placeholder="Redirect URI"
                  defaultValue={applicationData.redirect_uri}
                  id="RedirectUrl"
                  name="redirect_uri"
                  innerRef={register({
                    required: "Redirect URI is required",
                    pattern: {
                      value: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
                      message: "Invalid Redirect URI",
                    },
                  })}
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <div className="col-12 col-sm-5 pl-6 mt-2 mt-sm-3 mt-lg-2 pr-sm-0 pr-6" style={{ width: "320px" }}>
                <SikkaDropzone
                  files={avatar}
                  onChange={(files) => {
                    setAvatar(files);
                    setDefaultLogoBoolean(false);
                    setAvatarChanged(true);
                  }}
                  multiple={false}
                  className="p-1"
                  accept="image/gif, image/jpeg, image/png"
                  preview={false}
                  placeholder="Select Application Logo"
                  maxSize={2097152}
                  minSize={0}
                  note="File size should not exceed 2 MB"
                />
              </div>
              <Col className="d-flex align-items-center justify-content-center">
                {avatar[0].base64 ? (
                  <img
                    id="app_logo"
                    className="img-thumbnail img-fluid mb-3 mt-2 ml-3"
                    style={{ border: "1px solid #ddd" }}
                    src={avatar[0].base64}
                    crossOrigin="anonymous"
                    width="150"
                    alt=""
                  />
                ) : defaultLogoBoolean ? (
                  <img
                    id="app_logo"
                    className="img-thumbnail img-fluid mb-3 mt-2 ml-3"
                    style={{ border: "1px solid #ddd" }}
                    // src={isIterableArray(avatar) ? avatar[0].base64 || avatar[0].src : ""}
                    src={defaultAppLogo}
                    crossOrigin="anonymous"
                    width="150"
                    alt=""
                  />
                ) : (
                  <img
                    id="app_logo"
                    className="img-thumbnail img-fluid mb-3 mt-2 ml-3"
                    style={{ border: "1px solid #ddd" }}
                    src={recordForEdit?.app_logo}
                    width="150"
                    alt=""
                  />
                )}
                {!defaultLogoBoolean && (
                  <Button
                    size="sm"
                    color="primary"
                    className="ml-4 mb-1"
                    onClick={() => {
                      let idx = partnerDetails.username.indexOf("@");
                      setClearBitImg(partnerDetails.username.slice(idx + 1));
                      setAvatar([{ src: "" }]);
                      setDefaultLogoBoolean(true);
                      setAvatarChanged(true);
                    }}
                  >
                    Reset Logo
                  </Button>
                )}
              </Col>
              {/* <Col className="col-xxl-6">
              <SikkaDropzone
                files={avatar}
                onChange={(files) => {
                  setAvatar(files);
                  setAvatarChanged(true);
                }}
                multiple={false}
                accept="image/gif, image/jpeg, image/png"
                preview={false}
                placeholder="Select Application Logo"
                maxSize={2097152}
                minSize={0}
                note="File size should not exceed 2 MB"
              />
              <img
                className="img-thumbnail img-fluid mb-3 mt-2"
                style={{ border: "1px solid #ddd" }}
                src={isIterableArray(avatar) ? avatar[0].base64 || recordForEdit?.app_logo : ""}
                width="150"
                alt=""
              />
            </Col> */}
            </Row>

            <Row
              form
              className="modal-footer px-md-4 bg-light"
              style={{
                marginBottom: "-16px",
                marginLeft: "-16px",
                marginRight: "-16px",
              }}
            >
              <Button color="outline-primary" size="sm" className="ml-auto" type="submit">
                Save
              </Button>
              <Button
                color="outline-secondary"
                size="sm"
                onClick={() => {
                  setOpenPopupForAddEditApplication(false);
                }}
              >
                Cancel
              </Button>
            </Row>
          </Form>
        )
      ) : (
        <Loader />
      )}
    </Fragment>
  );
};

export default AddEditApplicationForm;